// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1mgmW","itemTitle":"ClientEmergencyInfo_itemTitle___3ygp","itemText":"ClientEmergencyInfo_itemText__13c-F"};